'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Step, Stepper as MUIStepper } from '@mui/material';
import StepButton from '@mui/material/StepButton';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Typography from '@classify/react-core-components/Typography';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import getSteps from '../../_services/getSteps';
const Root = styled('nav')(({
  theme: {
    palette,
    spacing,
    breakpoints
  }
}) => ({
  display: 'none',
  position: 'sticky',
  top: 0,
  left: 0,
  alignItems: 'center',
  height: spacing(8),
  borderBottom: `1px solid ${palette.layout.line.divider}`,
  overflow: 'hidden',
  backgroundColor: palette.layout.background.navigation,
  zIndex: 1,
  scrollBehavior: 'smooth',
  [breakpoints.up('sm')]: {
    display: 'flex'
  }
}));
const Stepper = styled(MUIStepper)(({
  theme: {
    spacing
  }
}) => ({
  height: 80,
  padding: spacing(2, 0, 0, 0),
  overflowX: 'scroll',
  overflowY: 'hidden',
  whiteSpace: 'nowrap'
}));
const Separator = styled(ChevronRight)(({
  theme: {
    palette
  }
}) => ({
  color: palette.text.secondary
}));
export const Badge = styled('span', {
  shouldForwardProp: prop => !['isActive'].includes(prop as string)
})<{
  isActive: boolean;
}>(({
  theme: {
    spacing,
    palette,
    typography
  },
  isActive
}) => ({
  display: 'flex',
  justifyContent: 'center',
  width: spacing(3),
  height: spacing(3),
  borderRadius: '50%',
  backgroundColor: palette.primary.main,
  ...typography.subtitle1,
  color: `${palette.text.onContrasted} !important`,
  ...(!isActive && {
    backgroundColor: palette.icon.disabled
  })
}));
const HorizontalStepper = t0 => {
  const $ = _c(9);
  const {
    activeStep
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getSteps();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const steps = t1;
  const [currentStep, setCurrentStep] = useState(activeStep ?? -1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const getActiveStepFromScroll = () => {
        if (steps.length === 0) {
          return;
        }
        const viewportOffset = window.innerHeight * 0.3;
        let nextActiveStep = steps[0].order;
        steps.forEach(step => {
          const section = document.getElementById(step.slug);
          if (!section) {
            return;
          }
          if (section.getBoundingClientRect().top - viewportOffset <= 0) {
            nextActiveStep = step.order;
          }
        });
        setCurrentStep(nextActiveStep);
      };
      const handleScroll = () => {
        getActiveStepFromScroll();
      };
      getActiveStepFromScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      window.addEventListener("resize", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleScroll);
      };
    };
    t3 = [steps];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = step_0 => {
      setCurrentStep(step_0);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleClick = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator aria-label={translate("global.word.go_to")} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== currentStep) {
    t6 = steps.map(t7 => {
      const {
        slug,
        order,
        label,
        dataEvent,
        dataTestId
      } = t7;
      const isActive = currentStep === order || currentStep === -1;
      const completed = currentStep > order;
      return <Step key={slug} active={isActive} completed={completed}><StepButton onClick={() => handleClick(order)} icon={<Badge isActive={isActive}>{order + 1}</Badge>} data-testid={dataTestId} data-event={dataEvent} href={`#${slug}`}><Typography variant="h6" component="span">{label}</Typography></StepButton></Step>;
    });
    $[5] = currentStep;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <Root aria-label="stepper"><ContentWrapper><Stepper nonLinear={true} connector={t5}>{t6}</Stepper></ContentWrapper></Root>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default HorizontalStepper;